import { render, staticRenderFns } from "./Switcher.vue?vue&type=template&id=1e207e35&"
import script from "./Switcher.vue?vue&type=script&lang=ts&"
export * from "./Switcher.vue?vue&type=script&lang=ts&"
import style0 from "./Switcher.vue?vue&type=style&index=0&id=1e207e35&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports